export default Object.freeze({
  // MANAGE_ACCOUNT_
  TITLE: '내 계정관리',
  ADMIN_ID: '아이디',
  ADMIN_NAME: '운영자명',
  EMAIL: 'e메일 주소',
  POSITION: '직급',
  DEPARTMENT: '소속부서',
  SELECT_DEPARTMENT: '소속부서 선택',
  DUTY: '직책',
  SELECT_DUTY: '직책 선택',
  PHONE: '전화번호',
  PHONE_PLACEHOLDER: '숫자와 - 만 입력 가능',
  MOBILE: '휴대폰번호',
  SMS_CERT: '인증번호발송',
  CERTIFY_CODE: '인증코드 입력',
  SMS_CHECK: '인증완료',

  NOTICE_COMMERCE_ACCOUNT_INFO1: '* 대표 운영자 연락처 정보는 ',
  COMMERCE_MY_PAGE: '통합 마이페이지',
  NOTICE_COMMERCE_ACCOUNT_INFO2: '에서 관리할 수 있습니다.',

  SMS_CERT_SEND: '휴대폰 번호로 인증코드가 전송되었습니다.',
  SMS_CERT_ERROR: '휴대폰번호를 다시 확인 해 주세요.',
  SMS_CERT_DONE: '인증완료 된 휴대폰번호입니다.',
  SMS_AUTH_ERROR_LENGTH: '올바른 인증코드를 입력 해 주세요.',
  SMS_AUTH_ERROR: '인증코드가 잘못 입력되었습니다. 다시 확인해 주세요.',
  SMS_AUTH_SUCCESS: '인증 완료되었습니다.',

  MSG_SMS_AUTH: 'SMS 인증을 진행해 주시기 바랍니다.',
  MSG_NAME_NULL: '직급을 입력해 주세요.',
  MSG_PHONENO_NULL: '전화번호를 입력해 주세요.',

  MAG_CHANGE_OK: '운영자 계정 정보가 변경되었습니다.'
});
